<template>
  <v-snackbar
    :value="value || false"
    :timeout="computedTimeout"
    bottom
    :left="!$vuetify.rtl"
    :right="$vuetify.rtl"
    transition="scroll-y-reverse-transition"
    @input="(newValue) => $emit('input', newValue)">
    <VcAlert :width="288" v-bind="$attrs" :is-stripe="false" />
  </v-snackbar>
</template>

<script>
import VcAlert from '../VcAlert/VcAlert.vue';
export default {
  name: 'VcToast',
  components: { VcAlert },
  props: {
    /**
        Controls whether or not the toast is currently displayed, part of the v-model two way binding mechanism
       */
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * Set this prop to change the timeout of a specific toast instance.
     * The default value is 3000.
     * To change the timeout across the project, use the toastTimeout configuration when initializing the project.
     */
    timeout: {
      type: Number,
      required: false,
    },
  },
  computed: {
    computedTimeout() {
      return this.timeout || this.$ds.toastTimeout || 3000;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../scss/mixins.scss';
.v-snack--right {
  direction: ltr;
  ::v-deep .v-snack__wrapper {
    direction: rtl;
  }
}
::v-deep {
  .v-snack__action {
    display: none;
  }

  .v-snack__wrapper.theme--dark {
    background-color: transparent;
    min-height: unset;
    min-width: unset;
    margin: 16px;
    @include md-and-up {
      margin: 24px;
    }
  }

  .v-alert {
    margin-bottom: 0;
  }
}
</style>
